import { render, staticRenderFns } from "./skipordersummary.vue?vue&type=template&id=323d833e&"
import script from "./skipordersummary.vue?vue&type=script&lang=js&"
export * from "./skipordersummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports